<template lang="pug">
  .request-page.page
    .container.request-page__container
      .request-page__main
        .request-page__title
          h1.title Подача заявки
        .request-page__description Перед отправлением заявки внимательно прочитайте правила лагеря. Ознакомьтесь с документами, которые необходимо предоставить.
        .request-page__form
          .request_indeed(
            v-if="!childsData || childsData.length === 0 || !userData || userData.first_name.length === 0"
          )
            h3 Для отправки заявки:
            router-link.button.button_full(
              v-if="!userData || !userData.first_name || userData.first_name.length === 0"
              to="/pages/profile/"
            ) Заполните профиль
            router-link.button.button_full(
              v-if="!childsData || childsData.length === 0"
              to="/pages/profile/my-childs"
            ) Добавьте детей
          form(
            v-else
          )
            .request-page-form.form
              section.request-page-form__section
                .form__elem.form__elem_short
                  .form-elem(
                  :class="{ 'form-elem_error' : requireErrors.child }"
                  )
                    .form-elem__title Выберите ребенка
                    .form-elem__body
                      multiselect.custom-multiselect(
                      v-model="defaultChild"
                      placeholder="Выберите ребенка",
                      :options="childsOptions"
                      :label="'text'"
                      :multiple="false"
                      :showLabels="false"
                      :closeOnSelect="true"
                      :allowEmpty="false"
                      @select="changeChild"
                      )
                        template(
                        slot="noOptions"
                        ) Список пуст
                        template(
                        slot="noResult"
                        ) Ничего не найдено
              section.request-page-form__section
                .form__elem.form__elem_full
                  .form-elem
                    .form-elem__title Выберите документы
                    .form-elem__body
                      files-list(
                      :attachments="attachments"
                      )
              section.request-page-form__section
                .form__elem.form__elem_short
                  .form-elem(
                  :class="{ 'form-elem_error' : requireErrors.quota }"
                  )
                    .form-elem__title Выберите квоту
                    .form-elem__body
                      multiselect.custom-multiselect(
                      v-model="defaultShiftQuota"
                      placeholder="Выберите квоту",
                      :options="shiftQuotasOptions"
                      :label="'text'"
                      :multiple="false"
                      :showLabels="false"
                      :closeOnSelect="true"
                      :allowEmpty="false"
                      :disabled="quotaSelectDisabled"
                      @select="changeShiftQuota"
                      )
                        template(
                        slot="noOptions"
                        ) Список пуст
                        template(
                        slot="noResult"
                        ) Ничего не найдено
                    .form-elem__description Список доступных квот формируется на основе данных о ребенке, указанных в личном кабинете (дата рождения, пол, адрес прописки, фактический адрес, информация о школе)
              section.request-page-form__section
                .form__elem.form__elem_short
                  .form-elem(
                    :class="{ 'form-elem_error' : requireErrors.house }"
                  )
                    .form-elem__title Выберите корпус
                    .form-elem__body
                      multiselect.custom-multiselect(
                      v-model="defaultShiftHouses"
                      placeholder="Выберите корпус",
                      :options="shiftHousesOptions"
                      :label="'text'"
                      :multiple="false"
                      :showLabels="false"
                      :closeOnSelect="true"
                      :allowEmpty="false"
                      :disabled="houseSelectDisabled"
                      @select="changeShiftHouse"
                      )
                        template(
                        slot="noOptions"
                        ) Список пуст
                        template(
                        slot="noResult"
                        ) Ничего не найдено
              section.request-page-form__section
                .form__elem.form__elem_short
                  .form-elem(
                  :class="{ 'form-elem_error' : requireErrors.house }"
                  )
                    .form-elem__title Высокий приоритет
                    .form-elem__body.form-elem__body_lh-0
                      label.input-item
                        .input-item__input
                          .checkbox
                            input.checkbox__input(
                            type="checkbox"
                            v-model="highPriority"
                            )
                            .checkbox__icon
              section.request-page-form__section
                .form__elem
                  .form-elem
                    .form-elem__body
                      button.button.button_long.button_paint-secondary(
                        @click="onCreateOrder($event)"
                      ) Отправить заявку
                .form__elem.form__elem_short
                  .form-elem
                    .form-elem__body
                      .form-elem-list
                        .form-elem-list__item
                          .input-item.input-item_small(
                            :class="{ 'input-item_error' : requireErrors.consentModel }"
                          )
                            .input-item__input
                              label.checkbox
                                input.checkbox__input(
                                  type="checkbox"
                                  v-model="consentModel"
                                  @change="keymonitor"
                                )
                                .checkbox__icon
                            .input-item__body
                              .input-item__text Даю свое согласие на&#32;
                                a(
                                  href="/documents/ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ  РЦ ЛЕТО.docx"
                                  target="_blank"
                                ).link обработку персональных данных согласно ФЗ-152
                        .form-elem-list__item
                          .input-item.input-item_small(
                            :class="{ 'input-item_error' : requireErrors.familiarizationModel }"
                          )
                            .input-item__input
                              label.checkbox
                                input.checkbox__input(
                                  type="checkbox"
                                  v-model="familiarizationModel"
                                  @change="keymonitor"
                                )
                                .checkbox__icon
                            .input-item__body
                              .input-item__text Ознакомлен(а)&#32;
                                a(
                                  href="/documents/Условия приобретения путевки в лагеря РЦ Лето.docx"
                                  target="_blank"
                                ).link условиями приобретения путевки
      .request-page__side(
        v-if="shiftData"
      )
        .current-request-obj
          .current-request-obj__img
            img(
              v-if="shiftData.photos[0]"
              :src="shiftData.photos[0].preview_376x340"
            )
            img(
              v-else
              src="https://dummyimage.com/270x170/666166/fff.jpg"
            )
          .current-request-obj__body
            .current-request-obj__section
              .current-request-obj__name(v-if="shiftData.camp") {{ shiftData.camp.name }}
            .current-request-obj__section
              .current-request-obj__shift {{ shiftData.name }}
            .current-request-obj__section
              span.current-request-obj__date {{ shiftData.date_started | monthDayDate }} - {{ shiftData.date_finished | monthDayDate }}
            //- .current-request-obj__section
            //-   //- span.current-request-obj__date {{ shiftData.date_started | monthDayDate }} - {{ shiftData.date_finished | monthDayDate }}
            //-   span.current-request-obj__days 14 дней
            .current-request-obj__section(v-if="defaultShiftHouses.price")
              .current-request-obj__name {{ defaultShiftHouses.price }} рублей
    .request-page__footer.page__footer
      main-footer
</template>

<script>
import {mapActions, mapState} from "vuex";

import AttachFile from "@/components/attach-file/AttachFile";
import MainFooter from "@/components/footer/Footer";
import FilesList from "./components/FilesList";
import Multiselect from "vue-multiselect";

export default {
  name: "ShiftRequest",
  components: {
    Multiselect,
    FilesList,
    AttachFile,
    MainFooter
  },
  data() {
    return {
      consentModel: false,
      familiarizationModel: false,
      childsOptions: [],
      defaultChild: {
        text: "Выберите ребенка",
        value: null
      },
      shiftQuotasOptions: [],
      defaultShiftQuota: {
        text: "Выберите квоту",
        value: null
      },
      shiftHousesOptions: [],
      defaultShiftHouses: {
        text: "Выберите корпус",
        value: null
      },
      highPriority: false,
      childsData: null,
      shiftHousesData: null,
      shiftQuotasData: null,
      selectShiftQuota: null,
      attachments: [],
      requireErrors: {
        consentModel: false,
        familiarizationModel: false,
        child: false,
        quota: false,
        house: false
      },
      shiftData: null
    };
  },
  computed: {
    ...mapState(["userData"]),
    shiftId() {
      return Number(this.$route.params.shiftId);
    },
    quotaSelectDisabled() {
      if (this.defaultChild.value) {
        return false;
      }
      return true;
    },
    houseSelectDisabled() {
      if (this.defaultShiftQuota.value) {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions(["getChilds", "createOrders", "getShift", "getQuotas", "getQuotasHouses"]),
    keymonitor() {
      Object.keys(this.requireErrors).map(error => {
        this.requireErrors[error] = false;
        return error;
      });
    },
    changeChild(data) {
      this.defaultShiftQuota = {
        text: "Выберите квоту",
        value: null
      };
      this.shiftQuotasOptions = [];
      this.defaultShiftHouses = {
        text: "Выберите корпус",
        value: null
      };
      this.shiftHousesOptions = [];

      const child = this.childsData.find(el => el.id === data.value);
      if (child) {
        this.attachments = child.awards.map(el => {
          el.checked = false;
          return el;
        });
        this.getQuotas({
          campshift: this.shiftData.id,
          child: child.id
        }).then(res => {
          this.shiftQuotasOptions = res.map(item => {
            return {
              text: item.name,
              value: item.id
            };
          });
        });
      } else {
        this.attachments = [];
      }
      this.keymonitor();
    },
    changeShiftQuota(data) {
      this.shiftHousesOptions = [];
      this.defaultShiftHouses = {
        text: "Выберите корпус",
        value: null
      };
      this.getQuotasHouses({
        quota: data.value
      }).then(res => {
        this.shiftHousesOptions = res.map(item => {
          return {
            text: `${item.house_name} - ${item.price} рублей`,
            value: item.id,
            price: item.price
          };
        });
      });
      this.keymonitor();
    },
    changeShiftHouse() {
      this.keymonitor();
    },
    onCreateOrder(e) {
      e.preventDefault();
      const errors = [];
      if (!this.consentModel) {
        errors.push("consentModel");
      }
      if (!this.familiarizationModel) {
        errors.push("familiarizationModel");
      }
      if (!this.defaultChild.value) {
        errors.push("child");
      }
      if (!this.defaultShiftHouses.value) {
        errors.push("house");
      }
      if (errors.length > 0) {
        errors.map(error => {
          this.requireErrors[error] = true;
          return error;
        });
        return;
      }
      this.createOrders({
        campshift: this.shiftId,
        child: this.defaultChild.value,
        awards: this.attachments.filter(el => el.checked).map(el => el.id),
        quotashouse: this.defaultShiftHouses.value,
        high_priority: this.highPriority
      }).then(response => {
        if (response.status === 201) {
          this.$root.$emit("onShowNotificationModal", {
            text: "Ваша заявка оформлена"
          });
          this.consentModel = false;
          this.familiarizationModel = false;
          this.defaultChild = {
            text: "Выберите ребенка",
            value: null
          };
          this.defaultShiftHouses = {
            text: "Выберите корпус",
            value: null
          };
          this.attachments = [];
        } else if (response.status === 400) {
          if (response.data.inn) {
            this.$root.$emit("onShowConfirmModal", {
              text:
                "На момент заезда в выбранную смену вашему ребёнку уже будет 16 лет. Необходимо указать ИНН в личном кабинете.",
              buttonConfirmFunc: {
                func: this.relocateToChildInfo,
                params: []
              },
              buttonConfirmText: "Ок",
              buttonCancelText: "Отмена"
            });
          } else if (response.data.order) {
            this.$root.$emit("onShowErrorModal", {
              text: response.data.order[0].message
            });
          } else if (response.data.high_priority) {
            this.$root.$emit("onShowErrorModal", {
              text: "У вас уже есть заявка с высоким приоритетом на эти даты. Вы можете убрать высокий приоритет и подать заявку в данную смену."
            });
          } else {
            this.$root.$emit("onShowErrorModal", {
              text: "Ошибка"
            });
          }
        } else {
          alert(response.status);
        }
      });
    },
    relocateToChildInfo() {
      this.$router.push({
        name: "MyChilds",
        query: {child_id: this.defaultChild.value}
      });
    },
    buildCurrentShift() {
      this.$root.$emit("on-show-preloader");
      const _this = this;
      const getShiftPromise = new Promise((resolve, reject) => {
        _this.getShift(_this.shiftId).then(shiftRes => {
          _this.shiftData = shiftRes;
          resolve();
        });
      });
      getShiftPromise.then(() => {
        return new Promise((resolve, reject) => {
          _this.getChilds().then(data => {
            _this.childsData = data;
            data.map(child => {
              _this.childsOptions.push({
                text: `${child.last_name} ${child.first_name} ${child.fathers_name}`,
                value: child.id
              });
              return child;
            });
            resolve();
          });
        });
      }).then(() => {
        this.$root.$emit("on-hide-preloader");
      });
    }
  },
  mounted() {
    this.buildCurrentShift();
  }
};
</script>
